import React, { useEffect, useState } from 'react';
import { Icon, Intent } from '@blueprintjs/core';
import { FormSelect } from 'components/form-fields';
import { ShowHide } from 'components/layout';
import { ListingTable } from 'components/listing';

export function StatutoryEntry({
    statutoryDays,
    onStatutoryDaysChange,
    onValidChange,
    editMode
}) {
    const numberOfDays = [
        { id: 2, name: "2" },
        { id: 3, name: "3" },
        { id: 4, name: "4" }
    ];

    const dayOfWeeks = [
        { id: 1, name: "Monday" },
        { id: 2, name: "Tuesday" },
        { id: 3, name: "Wednesday" },
        { id: 4, name: "Thursday" },
        { id: 5, name: "Friday" },
        { id: 6, name: "Saturday" },
        { id: 7, name: "Sunday" }
    ];

    const [restDays, setRestDays] = useState([]);
    const [numberOfStatutoryDaysSelector, setNumberOfStatutoryDaysSelector] = useState(statutoryDays?.length || 0);
    const [isValid, setIsValid] = useState(false);
        
    useEffect(function () {
        onValidChange(isValid);
    }, [isValid]);

    useEffect(() => {
        setIsValid(numberOfStatutoryDaysSelector > 0 && statutoryDays?.length === numberOfStatutoryDaysSelector && statutoryDays.every(day => day > 0));

        const days = [];
        const availableDays = dayOfWeeks.filter(day => !statutoryDays?.includes(day.id));

        for (let i = 1; i <= numberOfStatutoryDaysSelector; i++) {
            const selectedDay = statutoryDays?.find((_, index) => index === i - 1);
            const listDays = ([
                ...availableDays,
                ...(selectedDay > 0 ? [dayOfWeeks.find(day => day.id === selectedDay)] : [])
            ]).sort((a, b) => a.id - b.id);

            days.push([
                `Rest day ${i}`,
                <FormSelect
                    key={`rest-day-selector${i}`}
                    items={listDays}
                    selectedValue={selectedDay}
                    onItemSelect={(selectedItem) => setSelectedStatutoryDays(i - 1, selectedItem)}
                    unit={!selectedDay ? <Icon icon="error" size={15} intent={Intent.DANGER} style={{ marginLeft: 4 }} /> : null}
                />
            ]);
        }

        setRestDays(days);
    }, [numberOfStatutoryDaysSelector, statutoryDays]);

    function onNumberOfStatutoryDaysSelectorChange(selectedItem) {
        setNumberOfStatutoryDaysSelector(selectedItem.id);
        onStatutoryDaysChange(Array.from({ length: selectedItem.id }, () => 0));
    }
    
    function setSelectedStatutoryDays(index, selectedItem) {
        const days = statutoryDays?.length > 0 ? [...statutoryDays] : Array.from({ length: numberOfStatutoryDaysSelector }, () => 0);

        if (days[index] === selectedItem.id) {
            days[index] = 0;
        } else {
            days[index] = selectedItem.id;
        }

        onStatutoryDaysChange(days);
    }

    return (
        <>
            <ShowHide
                evaluator={editMode}
                show={<h2>Edit Statutory Week Template</h2>}
                hide={<h2>Build Statutory Week Template</h2>}
            />

            <p className='spacer-bottom'>
                Your template must have a minimum of two rest days in a week, but you may add up to four. Adding more than two rest days will re-calculate available working hours for non-rest days within the template.
            </p>

            <FormSelect
                id="statutory-entry-day"
                headingText="Please select number of rest days"
                items={numberOfDays}
                onItemSelect={onNumberOfStatutoryDaysSelectorChange}
                selectedValue={numberOfStatutoryDaysSelector}
            />

            <ShowHide evaluator={numberOfStatutoryDaysSelector > 0}
                show={
                    <div style={{ width: "400px" }}>
                        <ListingTable
                            headers={["Rest Day", "Weekday"]}
                            data={restDays}
                            totalRecordCount={numberOfStatutoryDaysSelector}
                            loadingData={false}
                            pageable={false}
                        />
                    </div>
                }
            />

        </>
    );
}
